import React, { useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { Loader2 } from "lucide-react";

/** Link pessoal do convite (e-mail/WhatsApp): entra e vai para o 1º acesso. */
export default function AccessLink() {
  const { token } = useParams();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  // só entra com o clique da aluna: robôs que verificam links (Gmail, WhatsApp) abrem a página mas não clicam
  const enter = () => {
    setBusy(true);
    api.post("/auth/first-access-link", { token })
      .then((r) => { setUser(r.data); navigate("/primeiro-acesso", { replace: true }); })
      .catch((e) => { setError(formatApiError(e.response?.data?.detail)); setBusy(false); });
  };
  return (
    <div className="min-h-screen grid place-items-center bg-[#F8FAFC] px-4">
      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-6"><Brand size="md" /></div>
        {error ? (<>
          <p className="text-slate-700">{error}</p>
          <div className="flex flex-col gap-2 mt-6">
            <Link to="/login" className="h-11 rounded-lg grid place-items-center text-white font-semibold" style={{ background: "#1E9E2A" }}>Ir para o login</Link>
            <Link to="/esqueci-senha" className="text-sm text-slate-500 hover:underline">Esqueci minha senha</Link>
          </div>
        </>) : (<>
          <h1 className="font-display text-xl font-bold text-slate-900">Seu acesso à plataforma</h1>
          <p className="text-slate-500 mt-2 text-sm">Toque no botão abaixo para entrar e completar seu cadastro.</p>
          <button onClick={enter} disabled={busy} data-testid="access-link-enter"
            className="mt-6 w-full h-12 rounded-lg grid place-items-center text-white font-semibold disabled:opacity-70" style={{ background: "#1E9E2A" }}>
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Entrar na plataforma"}
          </button>
        </>)}
      </div>
    </div>
  );
}
